import { displayServiceError, hideServiceError } from "../components/serviceError";

const confirmCardRemovalEvents = relatedTarget => {
    const $triggeringBtn = $(relatedTarget);
    const url = $triggeringBtn.data("url") + "?cardId=" + $triggeringBtn.data("id");

    $(".delete-confirmation-btn").off("click").on("click", e => {
        e.preventDefault();
        $(".remove-payment").trigger("payment:remove", e);

        const deleteCardServiceErrorContainer = document.querySelector(".paymentInstruments").querySelector(".ct-service-error-container");
        hideServiceError(deleteCardServiceErrorContainer);

        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function (data) {
                if (data.error) {
                    displayServiceError(deleteCardServiceErrorContainer, data.message);
                } else {
                    $("#cardid-" + data.cardId).remove();
                }

                $("#delete-payment-modal").modal("hide");
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            }
        });
    });
};

export { confirmCardRemovalEvents };
